module.exports = __webpack_public_path__ + "img/emp4-1.5ea4103f.jpg";